// extracted by css-extract-rspack-plugin
export default {"footer":"_139b9cbc","footerRow":"_3deb9396","additionalLinkContainer":"_4f1175c7"};